<template>
  <div>
    components page2
  </div>
</template>

<script>
export default {
  name: 'componentspage2'
}
</script>

<style lang="stylus" scoped>

</style>
